import {
  getDa1AuthUniversalLoginUrl,
  isDa1AuthUniversalLoginHost,
  isDa1LegacyMarketingLoginHost,
} from 'common/HelperFunctions'
import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Navigate, Route, Routes} from 'react-router'
import {RootState} from 'setup'

import {UniversalLoginLayout} from './UniversalLoginLayout'
import {UniversalLoginPage} from './UniversalLoginPage'

/** Da1 universal login UI — mounted at /login on the auth subdomain. */
const AuthUniversalLogin = () => {
  const isLoggedIn = useSelector<RootState>(
    (state) => state.userReducer.isLoggedIn,
    shallowEqual
  ) as boolean

  if (isLoggedIn) {
    return <Navigate to='/dashboard?step=0' replace />
  }

  return (
    <Routes>
      <Route element={<UniversalLoginLayout />}>
        <Route index element={<UniversalLoginPage />} />
      </Route>
    </Routes>
  )
}

/**
 * Top-level /login — renders universal login on the auth host, redirects marketing
 * roots to the auth subdomain, and sends school hosts to /auth/login.
 */
const UniversalLoginRoute = () => {
  useEffect(() => {
    if (isDa1LegacyMarketingLoginHost()) {
      window.location.replace(getDa1AuthUniversalLoginUrl())
    }
  }, [])

  if (isDa1LegacyMarketingLoginHost()) {
    return null
  }

  if (isDa1AuthUniversalLoginHost()) {
    return <AuthUniversalLogin />
  }

  return <Navigate to='/auth/login' replace />
}

export {AuthUniversalLogin, UniversalLoginRoute}
